<div class="dataTable">
  <div class="row">    
      <div class="example-contaner mat-elevation-z8 tb-parent"> 
        <div class="itemCount">{{totalResult}} {{ "welcomePackage.itemFound" | cxTranslate }}</div>
        <app-scroll-container
        *ngIf="!isLoadMoreInProgress"
        [more]="true"
        [scrollDelay]="2000"
        [scrollOffset]="2000"
        (scrolled)="loadMoreOrders()"
        [class.full]="full"
        [class.part]="!full"
      >
            <mat-table #table [dataSource]="dataSource">
              <!-- Position Column -->
              <ng-container matColumnDef="Serial Number">
                <mat-header-cell *matHeaderCellDef class="tb-heading"> {{ "welcomePackage.serialNoHeader" | cxTranslate }} </mat-header-cell>
                <mat-cell *matCellDef="let element" class="tb-content" (click)="selectedItem(element)"> 
                  {{element.serialNumber}} </mat-cell>
              </ng-container>
          
              <!-- Name Column -->
              <ng-container matColumnDef="Part Number">
                <mat-header-cell *matHeaderCellDef class="tb-heading">{{ "welcomePackage.partNoHeader" | cxTranslate }}</mat-header-cell>
                <mat-cell *matCellDef="let element" class="tb-content"> {{element.partNumber}} </mat-cell>
              </ng-container>
          
              <!-- Weight Column -->
              <ng-container matColumnDef="Part Description">
                <mat-header-cell *matHeaderCellDef class="tb-heading">{{ "welcomePackage.partDescriptioHeader" | cxTranslate }}</mat-header-cell>
                <mat-cell *matCellDef="let element" class="tb-content"> 
                  <div  class="part-desp"
              matTooltipClass="vs-tooltip"
              matTooltipPosition="below"
              matTooltip="{{ element.partDescription }}"
            > {{element.partDescription}} 
            </div>
                </mat-cell>
              </ng-container>
        
              <ng-container matColumnDef="Sales Order Reference">
                <mat-header-cell *matHeaderCellDef class="tb-heading">{{ "welcomePackage.salesOrderHeader" | cxTranslate }}</mat-header-cell>
                <mat-cell *matCellDef="let element" class="tb-content"> {{element.salesOrderRef}} </mat-cell>
              </ng-container>
        
              <ng-container matColumnDef="Purchase Order Reference">
                <mat-header-cell *matHeaderCellDef class="tb-heading">{{ "welcomePackage.purchaseOrderHeader" | cxTranslate }}</mat-header-cell>
                <mat-cell *matCellDef="let element" class="tb-content"> {{element.poRef}} </mat-cell>
              </ng-container>
          
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let items; columns: displayedColumns;"></mat-row>
            </mat-table>
        </app-scroll-container>
        <div *ngIf="isLoadMoreInProgress">
          <cx-spinner></cx-spinner>
        </div>
        <div class="currently-loading-spinner" *ngIf="currentlyLoading && !isLoadMoreInProgress">
          <cx-spinner></cx-spinner>
        </div>
          <div class="itemCount">{{totalResult}} {{ "welcomePackage.itemFound" | cxTranslate }}</div>
        </div>  
    </div>  
</div>